import request from '@utils/axiosWrapper';
import { OldVersionAlertParams, OldVersionAlertResponse } from '../types';

/**
 * 获取商家升级引导配置
 * @param params 接口参数
 * @return 商家升级引导配置
 */
const getOldVersionAlert = (params: OldVersionAlertParams) =>
    request.get<OldVersionAlertResponse>('/gw/version/pc/oldVersionAlert', { params });

export default getOldVersionAlert;
